export default __webpack_public_path__ + "static/media/cloudy-night.667b2afa.mp4";